import { Button } from '@/components/ui/button';
import {
  ComboboxPopover,
  type Option,
} from '@/components/ui/combobox/combobox-popover';
import { Minus, Star, StarHalf } from 'lucide-react';
import { useMemo, useRef } from 'react';

const ENTIRE_OR_PARTIAL_OPTIONS_MAP: (Option<'yes' | 'no'> & {
  booleanValue: boolean;
})[] = [
  {
    value: 'yes',
    label: 'Yes',
    icon: <Star className="size-3.5" />,
    booleanValue: true,
  },
  {
    value: 'no',
    label: 'No',
    icon: <StarHalf className="size-3.5" />,
    booleanValue: false,
  },
];

export function PaymentEntireOrPartialSelect({
  value,
  setValue,
}: {
  value: 'yes' | 'no';
  setValue: (value: 'yes' | 'no') => void;
}) {
  const handleEntireOrPartialChange = (newEntireOrPartial: string) => {
    setValue(newEntireOrPartial as 'yes' | 'no');
  };

  const buttonRef = useRef<HTMLDivElement>(null);

  const currentOption = useMemo(() => {
    return ENTIRE_OR_PARTIAL_OPTIONS_MAP.find(
      (option) => option.value === value,
    );
  }, [value]);

  return (
    <ComboboxPopover
      endAdornment={null}
      placeholder="Set entire payment..."
      onChange={handleEntireOrPartialChange}
      emptyMessage="No entire payment selected"
      currentOption={currentOption}
      options={ENTIRE_OR_PARTIAL_OPTIONS_MAP}
      side="right"
      align="start"
    >
      <div ref={buttonRef}>
        <Button variant="ghost" className="p-1 h-fit">
          {value === null && (
            <>
              <Minus className="h-3.5 w-3.5" />
              <p className="rounded text-xs  text-gray-600">
                No Entire or Partial Selected
              </p>
            </>
          )}
          {value === 'yes' &&
            ENTIRE_OR_PARTIAL_OPTIONS_MAP.find((option) => option.booleanValue)
              ?.icon}
          {value === 'no' &&
            ENTIRE_OR_PARTIAL_OPTIONS_MAP.find((option) => !option.booleanValue)
              ?.icon}
          <p className="rounded text-xs  text-gray-600">
            {
              ENTIRE_OR_PARTIAL_OPTIONS_MAP.find(
                (option) => option.value === value,
              )?.label
            }
          </p>
        </Button>
      </div>
    </ComboboxPopover>
  );
}
